var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PanelList',{staticClass:"mt-3",attrs:{"items":_vm.leaseRequests,"title":"طلبات العقود","canSelectAll":false}},_vm._l((_vm.leaseRequests),function(leaseRequest,i){return _c('LeaseRequestPanelItem',{key:i,attrs:{"leaseRequest":leaseRequest}})}),1),_c('ResidentialLeaseModal'),_c('CommercialLeaseModal'),_c('SubLeaseModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }